import { MessageMedium } from 'constants/messageMediums';
import { TemplateType } from 'constants/templateTypes';
import { WhatsAppSender } from 'modules/sendingPlatforms/types/whatsAppSenders';
import { ReactNode } from 'react';
import { IndexPageTemplate } from './Template';

export enum MEDIUM_TYPES {
  IN_APP = 'In-App',
  WEB_PUSH = 'Web Push',
}

export type MediumSlugMapping = Record<MEDIUM_TYPES, string>;

export type PageInfo = {
  count: number;
  limit: number;
  offset: number;
  page: number;
};

export type TemplateTableColumn = {
  id: string;
  label: string;
  isSortable: boolean;
};

/* ACTION TYPES */
export type CreateTemplateProps = {
  currentFolderId: number | null;
  dragDropSlug?: string;
  defaultLocale?: string;
  messageMedium: string;
  name: string;
  templateType?: TemplateType;
  placementId?: number;
};

export type CopyTemplateProps = {
  currentFolderId: number | null;
  currentCampaignId?: number | null;
  destEmailSender?: string;
  destMessageTypeId?: number;
  destProjectId?: number;
  destProjectName?: string;
  destSmsSenderId?: number;
  name: string;
  refetch: () => void;
  srcTemplateId: number;
  triggeredBy: string;
  defaultLocaleToClone?: string;
  secondaryLocalesToClone?: string[];
  isCurrentProjInLocaleBeta?: boolean;
};

export type CopyTemplateResponseProps = {
  srcTemplateId: number;
  destTemplateId: number;
  destProjectId?: number;
  triggeredBy: string;
};

export type GetMessageTypesAndSendersProps = {
  projectId: number;
  messageMedium: string;
};

export type MessageType = {
  createdAt: number;
  id: number;
  messageChannelId: number;
  name: string;
  projectId: number;
  subscriptionPolicy: string;
  updatedAt: number;
};

export type SmsSender = {
  espAccountId: number;
  id: number;
  name: string;
  // its weird the phonenumber comes back as a string
  phoneNumber: string;
  projectId: number;
  type: string;
};

export type EmailSender = {
  authorized: boolean;
  defaultReplyTo: string;
  email: string;
  projectId: number;
  senderName: string;
};

export type MessageTypesAndSenders = {
  messageTypes?: MessageType[];
  emailSenders?: EmailSender[];
  smsSenders?: SmsSender[];
  whatsAppSenders?: WhatsAppSender[];
};

export type GetMessageTypesAndSendersResponseProps = {
  messageTypes: MessageType[];
  emailSenders: EmailSender[];
  smsSenders: SmsSender[];
  whatsAppSenders: WhatsAppSender[];
  projectId: number;
  messageMedium: string;
};

export type ProjectMessageMedia = Record<MEDIUM_TYPES, MessageTypesAndSenders>;

export interface TemplateIndexState {
  isFetchingMessageTypesAndSenders: boolean;
  projects: Record<number, ProjectMessageMedia>;
  previewThumbnails: Record<string, unknown>;
}

export interface TemplateIndexRootState {
  templateIndex: TemplateIndexState;
}

export type TemplateWithMessageMediumLabels = Omit<IndexPageTemplate, 'messageMedium'> & {
  messageMedium: string;
};

export type BasicOption = { label: string; id: string; suffix?: ReactNode };

export type GroupedOption = BasicOption & {
  isExpandableGroup?: boolean;
  options?: Array<BasicOption>;
};

export type FilterCategory = BasicOption & {
  forMedium: MessageMedium | string;
  hasFilter?: boolean;
  isSelectMenu: boolean;
  options: Array<BasicOption | GroupedOption>;
};

export type ExpandableFilterMap = { [id: string]: { parentId?: string; children?: BasicOption[] } };
